import EventsDetails from './EventsDetails'

export default EventsDetails
